const account = require('./account');
const bonusProductsView = require('../bonus-products-view');
const dialog = require('../dialog');
const productUtil = require('./product/productUtil');
const util = require('../util');
const quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    $('#cart-table').on('click', '.item-edit-details a', (e) => {
        // only Master-Variation Products get QV edit modal
        if ($(e.currentTarget).hasClass('qv-modal')) {
            e.preventDefault();
            quickview.show({
                url: `${e.target.href}`,
                source: 'cart',
            });
        }
    }).on('click', '.bonus-item-actions a, .item-details .bonusproducts a', (e) => {
        e.preventDefault();
        bonusProductsView.show(e.currentTarget.href);
    });
    // scroll to coupon section if there is an error or it has applied
    if ($('#coupon-error').length > 0 || $('.summary-coupon').length > 0) {
        $('html, body').animate({
            scrollTop: ($('.coupon-callout').offset().top),
        }, 200);
    }

    // Override enter key for coupon code entry
    $('form input[name$="_couponCode"]').on('keydown', (e) => {
        if (e.which === 13 && $(e.currentTarget).val().length === 0) {
            return false;
        } if (e.which === 13 && $(e.currentTarget).val().length > 0) {
            e.preventDefault();
            $('#add-coupon').click();
        }
        return true;
    });

    // To prevent multiple submissions of the form when updating/removing line items
    let updateItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', (e) => {
        if (updateItemEvent) {
            e.preventDefault();
        } else {
            updateItemEvent = true;
        }
    });

    // On change quantity input/select submit form
    $('.quantity-module').find('input, select').on('change', (e) => {
        if (updateItemEvent) {
            e.preventDefault();
        } else {
            $('#cart-items-form').submit();
            updateItemEvent = true;
        }
    });

    $('.esp-edit-details').on('click', (e) => {
        e.preventDefault();
        const target = $(e.currentTarget).closest('tr.cart-row');
        const formRow = target.prev();
        target.addClass('visually-hidden');
        formRow.removeClass('visually-hidden');
    });

    $('.esp-options').find('input').on('change', (e) => {
        if (updateItemEvent) {
            e.preventDefault();
        } else {
            $(e.currentTarget).closest('.esp-options').find('button').click();
            updateItemEvent = true;
        }
    });

    if ($('#cart-table').hasClass('limit-error')) {
        productUtil.showLimitErrorDialog();
        // Remove limit error from query string to prevent it from showing on page refresh
        if (window.history !== undefined && window.history.replaceState !== undefined) {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }

    // Display cart popup message
    const $basketError = $('.basketErrorPopup').first();
    if ($basketError.length > 0) {
        dialog.open({
            html: $basketError.find('.body').html(),
            options: {
                title: $basketError.find('.title').text(),
                buttons: [
                    {
                        text: Resources.OK,
                        class: 'button primary',
                        click() {
                            $(this).dialog('close');
                        },
                    },
                ],
            },
        });
    }
    if (SitePreferences.RECAPTCHA_ENABLED) {
        $('.fake-checkout').on('click', (e) => {
            e.preventDefault();
            /* global utag, utag_data */
            grecaptcha.ready(() => {
                grecaptcha.execute(SitePreferences.RECAPTCHA_KEY, {action: 'checkout'}).then((token) => {
                    const newURL = `${Urls.recaptchaRef}?token=${token}`;
                    $.ajax({
                        url: util.ajaxUrl(newURL),
                        success: (event) => {
                            const response = JSON.parse(event.response);
                            // eslint-disable-next-line
                            utag_data = {
                                recaptcha_action: response.action,
                                recaptcha_score: response.score,
                                recaptcha_success: response.success,
                            };
                            utag.view(utag_data);
                            utag.link({
                                recaptcha_action: response.action,
                                recaptcha_score: response.score,
                                recaptcha_success: response.success,
                            });
                        },
                    });
                });
            });
            setTimeout(() => {
                $('#checkout-form button').click();
            }, 3000);
        });
    } else {
        $('.fake-checkout').on('click', (e) => {
            e.preventDefault();
            $('#checkout-form button').click();
        });
    }

    $('.fake-checkout-continue').on('click', (e) => {
        e.preventDefault();
        $('#continue-shopping button').click();
    });

    $('.recommendations-container .tiles-container').slick({
        speed: 300,
        dots: false,
        arrows: true,
        slide: '.grid-tile',
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: util.getViewports('md'),
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 690,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
    util.initDynamicCarousel('[id^="cq_recomm_slot"]', '.recommendations-container .tiles-container', 0);
    util.initDynamicCarousel('[id^="cq_recomm_slot"]', '.recommendations-container .tiles-container', 1);

    $('input')
        .on('paste', (e) => {
            e.preventDefault();
            const pastedData = e.originalEvent.clipboardData.getData('text');
            $(e.target).val(pastedData.trim());
        })
        .on('blur', (e) => {
            const currentValue = $(e.target).val();
            $(e.target).val(currentValue.trim());
        });
}

exports.init = function init() {
    initializeEvents();
    account.initCartLogin();
};
